var map = {
	"./3_bird_fly.gif": "./src/EGRContent/Story/KabiKoMayur/images/3_bird_fly.gif",
	"./7_bird_fly.gif": "./src/EGRContent/Story/KabiKoMayur/images/7_bird_fly.gif",
	"./bg_back_page_3.jpg": "./src/EGRContent/Story/KabiKoMayur/images/bg_back_page_3.jpg",
	"./bg_front_page_3.png": "./src/EGRContent/Story/KabiKoMayur/images/bg_front_page_3.png",
	"./bg_page_01.jpg": "./src/EGRContent/Story/KabiKoMayur/images/bg_page_01.jpg",
	"./bg_page_02.jpg": "./src/EGRContent/Story/KabiKoMayur/images/bg_page_02.jpg",
	"./bg_page_02_a.jpg": "./src/EGRContent/Story/KabiKoMayur/images/bg_page_02_a.jpg",
	"./bg_page_03.jpg": "./src/EGRContent/Story/KabiKoMayur/images/bg_page_03.jpg",
	"./bg_page_04.jpg": "./src/EGRContent/Story/KabiKoMayur/images/bg_page_04.jpg",
	"./bg_page_05.jpg": "./src/EGRContent/Story/KabiKoMayur/images/bg_page_05.jpg",
	"./bg_page_06.jpg": "./src/EGRContent/Story/KabiKoMayur/images/bg_page_06.jpg",
	"./bg_page_07.jpg": "./src/EGRContent/Story/KabiKoMayur/images/bg_page_07.jpg",
	"./bg_page_08.jpg": "./src/EGRContent/Story/KabiKoMayur/images/bg_page_08.jpg",
	"./bg_page_09.jpg": "./src/EGRContent/Story/KabiKoMayur/images/bg_page_09.jpg",
	"./bg_page_10.jpg": "./src/EGRContent/Story/KabiKoMayur/images/bg_page_10.jpg",
	"./bg_page_11.jpg": "./src/EGRContent/Story/KabiKoMayur/images/bg_page_11.jpg",
	"./bg_page_12.jpg": "./src/EGRContent/Story/KabiKoMayur/images/bg_page_12.jpg",
	"./bg_page_13.jpg": "./src/EGRContent/Story/KabiKoMayur/images/bg_page_13.jpg",
	"./bg_page_14.jpg": "./src/EGRContent/Story/KabiKoMayur/images/bg_page_14.jpg",
	"./boy_on_cycle.png": "./src/EGRContent/Story/KabiKoMayur/images/boy_on_cycle.png",
	"./boy_on_cycle_01.png": "./src/EGRContent/Story/KabiKoMayur/images/boy_on_cycle_01.png",
	"./chiks_moving.gif": "./src/EGRContent/Story/KabiKoMayur/images/chiks_moving.gif",
	"./chiks_moving.png": "./src/EGRContent/Story/KabiKoMayur/images/chiks_moving.png",
	"./circle.png": "./src/EGRContent/Story/KabiKoMayur/images/circle.png",
	"./clouds.png": "./src/EGRContent/Story/KabiKoMayur/images/clouds.png",
	"./cover_page.jpg": "./src/EGRContent/Story/KabiKoMayur/images/cover_page.jpg",
	"./credit_page.png": "./src/EGRContent/Story/KabiKoMayur/images/credit_page.png",
	"./cycle_rickshaw.png": "./src/EGRContent/Story/KabiKoMayur/images/cycle_rickshaw.png",
	"./cycle_rickshaw_r.png": "./src/EGRContent/Story/KabiKoMayur/images/cycle_rickshaw_r.png",
	"./egg_boil.png": "./src/EGRContent/Story/KabiKoMayur/images/egg_boil.png",
	"./egg_page5.png": "./src/EGRContent/Story/KabiKoMayur/images/egg_page5.png",
	"./egg_taking_home.png": "./src/EGRContent/Story/KabiKoMayur/images/egg_taking_home.png",
	"./hen.gif": "./src/EGRContent/Story/KabiKoMayur/images/hen.gif",
	"./hen_01.gif": "./src/EGRContent/Story/KabiKoMayur/images/hen_01.gif",
	"./hen_searching_food.gif": "./src/EGRContent/Story/KabiKoMayur/images/hen_searching_food.gif",
	"./hen_searching_food.png": "./src/EGRContent/Story/KabiKoMayur/images/hen_searching_food.png",
	"./hen_searching_food_new.gif": "./src/EGRContent/Story/KabiKoMayur/images/hen_searching_food_new.gif",
	"./hen_with_mayur.gif": "./src/EGRContent/Story/KabiKoMayur/images/hen_with_mayur.gif",
	"./holding_egg.gif": "./src/EGRContent/Story/KabiKoMayur/images/holding_egg.gif",
	"./house_page16.png": "./src/EGRContent/Story/KabiKoMayur/images/house_page16.png",
	"./img01.png": "./src/EGRContent/Story/KabiKoMayur/images/img01.png",
	"./img02.png": "./src/EGRContent/Story/KabiKoMayur/images/img02.png",
	"./img03.png": "./src/EGRContent/Story/KabiKoMayur/images/img03.png",
	"./img04.png": "./src/EGRContent/Story/KabiKoMayur/images/img04.png",
	"./img05.png": "./src/EGRContent/Story/KabiKoMayur/images/img05.png",
	"./img06.png": "./src/EGRContent/Story/KabiKoMayur/images/img06.png",
	"./img07.png": "./src/EGRContent/Story/KabiKoMayur/images/img07.png",
	"./img08.png": "./src/EGRContent/Story/KabiKoMayur/images/img08.png",
	"./img10.png": "./src/EGRContent/Story/KabiKoMayur/images/img10.png",
	"./img11.png": "./src/EGRContent/Story/KabiKoMayur/images/img11.png",
	"./img12.png": "./src/EGRContent/Story/KabiKoMayur/images/img12.png",
	"./img13.png": "./src/EGRContent/Story/KabiKoMayur/images/img13.png",
	"./img13_new.png": "./src/EGRContent/Story/KabiKoMayur/images/img13_new.png",
	"./img14.png": "./src/EGRContent/Story/KabiKoMayur/images/img14.png",
	"./keep_with_hen.gif": "./src/EGRContent/Story/KabiKoMayur/images/keep_with_hen.gif",
	"./keep_with_hen.png": "./src/EGRContent/Story/KabiKoMayur/images/keep_with_hen.png",
	"./kids_play_foot_ball_300.gif": "./src/EGRContent/Story/KabiKoMayur/images/kids_play_foot_ball_300.gif",
	"./mayur.gif": "./src/EGRContent/Story/KabiKoMayur/images/mayur.gif",
	"./mayur.png": "./src/EGRContent/Story/KabiKoMayur/images/mayur.png",
	"./page13.jpg": "./src/EGRContent/Story/KabiKoMayur/images/page13.jpg",
	"./page14.jpg": "./src/EGRContent/Story/KabiKoMayur/images/page14.jpg",
	"./page15.jpg": "./src/EGRContent/Story/KabiKoMayur/images/page15.jpg",
	"./page3.jpg": "./src/EGRContent/Story/KabiKoMayur/images/page3.jpg",
	"./page3a.jpg": "./src/EGRContent/Story/KabiKoMayur/images/page3a.jpg",
	"./page7.jpg": "./src/EGRContent/Story/KabiKoMayur/images/page7.jpg",
	"./peacock.png": "./src/EGRContent/Story/KabiKoMayur/images/peacock.png",
	"./peacock_dancing-min.gif": "./src/EGRContent/Story/KabiKoMayur/images/peacock_dancing-min.gif",
	"./peacock_dancing.gif": "./src/EGRContent/Story/KabiKoMayur/images/peacock_dancing.gif",
	"./peacock_dancing.png": "./src/EGRContent/Story/KabiKoMayur/images/peacock_dancing.png",
	"./peacock_walk.gif": "./src/EGRContent/Story/KabiKoMayur/images/peacock_walk.gif",
	"./play_football.gif": "./src/EGRContent/Story/KabiKoMayur/images/play_football.gif",
	"./play_football_new.gif": "./src/EGRContent/Story/KabiKoMayur/images/play_football_new.gif",
	"./play_football_new.png": "./src/EGRContent/Story/KabiKoMayur/images/play_football_new.png",
	"./pointing_egg.gif": "./src/EGRContent/Story/KabiKoMayur/images/pointing_egg.gif",
	"./pointing_egg.png": "./src/EGRContent/Story/KabiKoMayur/images/pointing_egg.png",
	"./sample_page.png": "./src/EGRContent/Story/KabiKoMayur/images/sample_page.png",
	"./sun01.png": "./src/EGRContent/Story/KabiKoMayur/images/sun01.png",
	"./sunset.jpg": "./src/EGRContent/Story/KabiKoMayur/images/sunset.jpg",
	"./sunset_boy_pealing_egg.jpg": "./src/EGRContent/Story/KabiKoMayur/images/sunset_boy_pealing_egg.jpg",
	"./they_are_going_home.gif": "./src/EGRContent/Story/KabiKoMayur/images/they_are_going_home.gif",
	"./thumbnail.png": "./src/EGRContent/Story/KabiKoMayur/images/thumbnail.png",
	"./wow_eggs.gif": "./src/EGRContent/Story/KabiKoMayur/images/wow_eggs.gif",
	"./wow_eggs.png": "./src/EGRContent/Story/KabiKoMayur/images/wow_eggs.png",
	"./writing.png": "./src/EGRContent/Story/KabiKoMayur/images/writing.png",
	"./yellow_sun.png": "./src/EGRContent/Story/KabiKoMayur/images/yellow_sun.png",
	"./yellow_sun01.png": "./src/EGRContent/Story/KabiKoMayur/images/yellow_sun01.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/EGRContent/Story/KabiKoMayur/images sync recursive ^\\.\\/.*$";